/**
 * Questo file contiene l'enum di possibili pagine di selezione dell'area
 */
 export enum SelezioneArea {
	Area = 1,
	AreaCAP = 2
}
